import {
  SHTableBody,
  SHTableCell,
  SHTableRow,
} from "@components/design-systems";
import { PortfolioCompositionSectionDTO } from "@models/platform-analysis/entities/steps/summary";
import { memo } from "react";
import { SummaryPortfolioCompositionCellValue } from "../../rendered-items/cell-value";
import { SummaryPortfolioCompositionRowTitle } from "../../rendered-items/row-title";

interface SummaryPortfolioCompositionTableBodyProps {
  sections?: PortfolioCompositionSectionDTO[];
}

export const SummaryPortfolioCompositionTableBody = memo(
  ({ sections }: SummaryPortfolioCompositionTableBodyProps) => {
    return (
      <SHTableBody>
        {sections?.map((section, sectionIndex) => {
          const { rows } = section;

          return rows?.map((row, rowIndex) => {
            const { cells, name, isSingleRow, isSubTotal } = row;

            return (
              <SHTableRow
                key={`${sectionIndex}-${rowIndex}`}
                className={`PortfolioCompositionTableBodyRow ${
                  isSingleRow ? "SingleRow" : ""
                } ${isSubTotal ? "SubTotalRow" : ""}`}
              >
                <SHTableCell>
                  <SummaryPortfolioCompositionRowTitle title={name} />
                </SHTableCell>

                {cells?.map((cell, cellIndex) => {
                  return (
                    <SHTableCell key={cellIndex}>
                      <SummaryPortfolioCompositionCellValue cell={cell} />
                    </SHTableCell>
                  );
                })}
              </SHTableRow>
            );
          });
        })}
      </SHTableBody>
    );
  },
);
